module.exports = __webpack_public_path__ + "static/media/pause.c6e4c9f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pause.svg
// module id = 1577
// module chunks = 1